import { getPageProperty } from "notion-utils"

export const getProperty = (name: string, post: any) => {
	const block = post.block[post.id]?.value
	return getPageProperty(name, block, post)
}
